// extracted by mini-css-extract-plugin
export default {"section_container":"PartOrderDetails_section_container__v-Vak","title_page":"PartOrderDetails_title_page__Y1NKe","inner_container":"PartOrderDetails_inner_container__N59zl"};